import React, { FC, PropsWithChildren } from "react";
type Props = PropsWithChildren<{
  renderIn: boolean;
}>;
export const RenderIn: FC<Props> = ({ children, renderIn }) => {
  if (!renderIn) return <></>;

  return <>{children}</>;
};
